import { render } from "./TeamPreview.vue?vue&type=template&id=2c880eee&scoped=true"
import script from "./TeamPreview.vue?vue&type=script&lang=js"
export * from "./TeamPreview.vue?vue&type=script&lang=js"

import "./TeamPreview.vue?vue&type=style&index=0&id=2c880eee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c880eee"]])

export default __exports__